import React from 'react';
import CheckIcon from '@wix/da-ds/pkg/Icons/16x16/Check';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Flex from '@wix/da-ds/pkg/Flex';

import s from './BenefitPlaceholder.scss';

export interface Props {}

const BenefitPlaceholder: React.FC<Props> = () => (
  <Flex alignItems="flex-start">
    <CheckIcon className={s['icon']} size={IconSize.SMALLER} disableDefaultColors />
    <div className={s['lines']}>
      <div className={s['line']} />
      <div className={s['line']} />
    </div>
  </Flex>
);
BenefitPlaceholder.displayName = 'BenefitPlaceholder';

export default BenefitPlaceholder;
